// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./replay.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".videoPlayBtn-2ksMjaaG {\n    width: 98px;\n    height: 98px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    z-index: 80;\n    background-size: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n}\n\n.playingBtn-xIsd1Fcr {\n    background-image: url('https://x0.ifengimg.com/cmpp/2020/0313/d16118b0bbddf15size3_w98_h98.png');\n}\n\n.pauseBtn-3S_EHpcK {\n    background-image: url('https://x0.ifengimg.com/cmpp/2020/0321/5c091c6faa74a99size2_w98_h98.png');\n}\n\n.replayBtn-2gB-xG4H {\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n}\n", ""]);
// Exports
exports.locals = {
	"videoPlayBtn": "videoPlayBtn-2ksMjaaG",
	"playingBtn": "playingBtn-xIsd1Fcr",
	"pauseBtn": "pauseBtn-3S_EHpcK",
	"replayBtn": "replayBtn-2gB-xG4H"
};
module.exports = exports;
